import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFullLengthTests = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4543 3H7.57661C6.15359 3 5 4.15359 5 5.57661V17.6154C5 19.0384 6.15359 20.192 7.57661 20.192H16.1757C17.5988 20.192 18.7524 19.0384 18.7524 17.6154V7.2978M14.4543 3H14.751C15.4344 3 16.0897 3.27146 16.5729 3.75467L17.9977 5.17942C18.4809 5.66263 18.7524 6.318 18.7524 7.00136V7.2978M14.4543 3V5.42163C14.4543 6.45781 15.2943 7.2978 16.3305 7.2978H18.7524",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9.23652,
			y1: 12.5218,
			x2: 14.5159,
			y2: 12.5218,
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 9.23652,
			y1: 15.9554,
			x2: 11.9364,
			y2: 15.9554,
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgFullLengthTests);
export { ForwardRef as ReactComponent };
